import { useCallback, useMemo, memo } from 'react';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { useTableDispatch, useTableSelector } from '../../redux/reduxHooks';
import { makeGetIsRowSelected, setRowsSelected } from '../redux/selectionSlice';
import styled from 'styled-components';
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { useTrellisTheme } from '../../utils/useTrellisTheme';
import { jsx as _jsx } from "react/jsx-runtime";
const CheckboxTD = styled.td.withConfig({
  displayName: "SelectRowCheckboxCell__CheckboxTD",
  componentId: "sc-1m1kjf-0"
})(["padding:", ";&&&{border-left-width:0;}"], ({
  $theme
}) => $theme.space['0']);
const StickyCheckboxTD = styled(CheckboxTD).withConfig({
  displayName: "SelectRowCheckboxCell__StickyCheckboxTD",
  componentId: "sc-1m1kjf-1"
})(["position:sticky;left:0;background-color:", ";z-index:3;"], ({
  $theme
}) => $theme.color['fill-surface-default']);
const SelectRowCheckboxCell = ({
  numberOfFrozenColumns = 0,
  rowId
}) => {
  const getIsRowSelected = useMemo(() => makeGetIsRowSelected(rowId), [rowId]);
  const isSelected = useTableSelector(getIsRowSelected);
  const dispatch = useTableDispatch();
  const handleChange = useCallback(({
    target: {
      checked
    }
  }) => dispatch(setRowsSelected([{
    rowId,
    selected: checked
  }])), [dispatch, rowId]);
  const Component = numberOfFrozenColumns > 0 ? StickyCheckboxTD : CheckboxTD;
  const theme = useTrellisTheme();
  return /*#__PURE__*/_jsx(Component, {
    $theme: theme,
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      flexGrow: 1,
      children: /*#__PURE__*/_jsx(Checkbox, {
        "aria-label": I18n.text('datatable.selectRowCheckbox.ariaLabel'),
        "data-test-id": `checkbox-select-row-${rowId}`,
        checked: isSelected,
        onChange: handleChange
      })
    })
  });
};
export default /*#__PURE__*/memo(SelectRowCheckboxCell);